package com.milta.core.localization.translations.pl

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Zaimportuj plik",
    analysingTitle = "Analiza pliku…",
    analysingSubtitle = "Identyfikujemy kolumny i wykrywamy dostawy w arkuszu.",
    fileSentSuffix = "wysłano przed chwilą",
    structuredFormatBannerTitle = "Format rozpoznany.",
    structuredFormatBannerMessage = "Kolumny zostały automatycznie zmapowane, korekta nie jest potrzebna.",
    columnsInterpretedBannerTitle = "Kolumny zinterpretowane automatycznie.",
    columnsInterpretedBannerMessage = "Sprawdź oznaczone dostawy przed ich dodaniem.",
    completePillLabel = "Wszystko jest kompletne",
    invalidFileTitle = "Plik nieobsługiwany.",
    invalidFileMessage = "Zaimportuj poprawny plik Excel (.xlsx) lub CSV (.csv).",
    chooseAnotherFileButton = "Wybierz inny plik",
    extractionFailedTitle = "Nie można odczytać tego pliku.",
    extractionFailedMessage = "Arkusz wydaje się pusty lub jego struktura nie została rozpoznana — sprawdź jego zawartość lub wprowadź dostawy ręcznie.",
    retryWithNewFileButton = "Spróbuj ponownie z innym plikiem",
    serviceUnavailableTitle = "Usługa analizy jest tymczasowo niedostępna.",
    serviceUnavailableMessage = "Spróbuj ponownie za chwilę lub uzupełnij tę dostawę ręcznie w międzyczasie.",
)
